import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {FileDataUpload} from '@shared-types/shared-file';
import {Observable} from 'rxjs';
import {UploadProcessResponse} from "@shared-interfaces/shared-upload";

export const URLS = {
  SUBSCRIPTION: 'subscription-data',
  PROFILE: 'profile',
  GENAI: 'genai',
  PROCESS: 'process',
  UPLOAD_FILE: 'api/v1/file/upload',
  EXECUTION: 'api/v1/flow/execution',
  DELETE_FILE: 'file/delete',
  UPDATE_FILE: 'file/upload/update',
  EXTRACT_TEXT: 'extract/text',
  ENTITLEMENT_OVERVIEW: 'entitlement/overview',
  ENTITLEMENT_UPDATE: 'entitlement',
  WORKFLOW: 'workflow',
  PROPOSAL: 'proposal/creation',
  STORYLINE_CREATE: 'storyline/create',
  STORYLINE_MAP: 'storyline/map',
  rfp_information: 'workflow/rfp-information',
  proposal: 'workflow/proposal',
  insight: 'workflow/insight',
  synthesis: 'workflow/synthesis'
};

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  constructor(private http: HttpClient) {}

 // API requests
  getSignedUrl(file: FileDataUpload): Observable<UploadProcessResponse> {
    let file_extension: string = file.file.name.split('.').pop()!;
    let original_filename: string = file.file.name.substring(0, file.file.name.lastIndexOf('.'));
    return this.http
        .get<UploadProcessResponse>(
            `${URLS.UPLOAD_FILE}/${file.workflowId}`,
            {
              params: {
                file_extension: file_extension.toLowerCase(),
                workflow_type: file.workflowType,
                original_filename: `${original_filename}.${file_extension.toLowerCase()}`,
              }
            }
        )
  }

  uploadToSignedUrl(file: File, signedUrl: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/octet-stream'
    });

    return this.http.put(signedUrl, file, { headers });
  }

  updateFiles(fileName?: string) {
    return this.http.put(URLS.UPDATE_FILE, fileName || '');
  }

  public deleteFile(workflowId: string, fileStoredName: string) {
    return this.http.post(`${URLS.EXECUTION}/delete_file_from_contract`, {
      content_collection_id: workflowId,
      file_ids: [fileStoredName]
    })
  }

  
}
